export default "__VITE_ASSET__dZ5rwCoR__"